export interface AppointmentSchedulerConfirmationType {
  appointmentSchedulerConfirmationTypeId: number;
  appointmentSchedulingCode: string;
  appointmentConfirmationCode: string;
  descriptio: string;
}
